import axios from 'axios'

// create an axios instance
const service = axios.create({
  baseURL: "/api", // api 的 base_url
  withCredentials: true, // 跨域请求时发送 cookies
  timeout: 500000 // request timeout
})
service.all = axios.all
// request interceptor
service.interceptors.request.use(
  config => {
    return config
  },
  error => {
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(

  response => {
    const res = response.data

    if(res.hasOwnProperty('succeed')){
      res.success = res.succeed
      if(res.success){
        localStorage.setItem('loginTime', new Date().getTime()+''); //更新登陆时间
      }
      return res
    }

    if(!res.hasOwnProperty('success')){
      return res;
    }

    if (res.success != true) {

      return Promise.reject(res.message||res.msg || 'error')
    } else {
      return res
    }
  },
  error => {
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js